import Card from '../UI/Card'

const Teacher = ( {image, name, title, socials}) => {
  return (
    <Card className="teacher">
        <div className='teacher__img'>
            <img src={image} alt={name} />
        </div>
        <h3>{name}</h3>
        <p>{title}</p>
        <div className='teacher__socials'>
            {
                socials.map(({icon, link}, index) => {
                  return <a key={index} href={link} target="_blank" rel='noreferrer'>{icon}</a>
                })
            }
        </div>
    </Card>
  )
}

export default Teacher